// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"0925c788","5794":"0925c788","6260":"edda148a","7693":"b6df3cc9","9492":"b6df3cc9"}[chunkId] + ".chunk.css";
};